export enum OrderDirection {
  Sell = 0,
  Buy = 1,
}
